@if (header) {
<div class="p-2 pt-3 pb-3 category-header group-header">
  <span class="divider-text text-capitalize">{{ header }}</span>
</div>
}
